import {
    Box,
    createStyles,
    List,
    ListItem,
    makeStyles,
    Paper,
    Grid,
    Theme,
    Typography,
    Button,
} from '@material-ui/core';
import axios from 'axios';
import clsx from 'clsx';
import { useSnackbar } from 'notistack';
import React, {
    useRef,
    useEffect,
    useState,
    useCallback,
    Fragment,
} from 'react';
import { useHistory } from 'react-router-dom';
import { borderRadius } from 'react-select/src/theme';
import ToastStr from '../../request/toastStr';
import {
    member as v_member,
    basic,
    Values,
    member,
    product as v_product,
    SPLASH_TIME,
    SNACKBAR_TIME,
} from '../../request/values';
import {
    DialogConfirm,
    DialogConfirm2,
    DialogConfirmDetail,
    DialogInputConfirm,
    DialogPopup,
    DialogSelectCompany,
} from '../Dialog';
import TitleBar from '../header/TitleBar';
import { COLORS } from '../Theme';
import Skeleton from '@material-ui/lab/Skeleton';

const SERVER = basic.server;

const useStyles = makeStyles((theme: Theme) => ({
    list: {
        padding: 0,
        width: '100%',
        height: '74vh',
        overflowY: 'auto',
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        fontSize: '4vw',
        color: `${COLORS.BROWNISH_GREY}`,
        [theme.breakpoints.up('md')]: {
            height: '100%',
            fontSize: 'initial',
        },
    },
    productItem: {
        borderRadius: 5,
        border: 'solid 1px #d3d3d3',
        marginBottom: '1.7vh',

        width: '100%',
        margin: 0,
        padding: '1vh 3vw',

        '& #itemWrap': {
            width: '100%',
            display: 'flex',
            padding: '0',
            justifyContent: 'center',
            // alignItem: 'center',
        },
        [theme.breakpoints.up('md')]: {
            paddingLeft: '25px',
            paddingRight: '30px',
            paddingTop: '22px',
            paddingBottom: '22px',
        },
    },

    productImage: {
        textAlign: 'center',
        margin: 'auto',
        '& img': {
            // width: '18vw',
            height: '6.5vh',
        },
    },
    button: {
        borderRadius: 5,
        width: '30%',
        height: '4vh',
        padding: 0,
        backgroundColor: `${COLORS.WATER_BLUE}`,
        color: `${COLORS.WHITE}`,

        ...theme.typography.body1,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        [theme.breakpoints.up('md')]: {
            padding: '25px 0',
            ...theme.typography.body1,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
        },
    },
    button2: {
        borderRadius: 5,
        width: '25vw',
        height: '4vh',
        marginBottom: '1.7vh',
        padding: 0,
        backgroundColor: `${COLORS.WATER_BLUE}`,
        color: `${COLORS.WHITE}`,
        ...theme.typography.body1,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
    },
    button3: {
        width: 'auto',
        height: 'auto',
        borderRadius: '5px',
        backgroundColor: `${COLORS.WATER_BLUE}`,
        color: `${COLORS.LIGHT_GREY}`,
        padding: '1vw',
        ...theme.typography.body1,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
    },
    productDesc: {
        //paddingLeft: '5vw',
        textAlign: 'center',
        flexGrow: 1,
        [theme.breakpoints.up('md')]: {
            paddingLeft: '0px',
        },
        '& #productName': {
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            ...theme.typography.body1,
            color: `${COLORS.BROWNISH_GREY}`,
        },
        '& #productPrice': {
            ...theme.typography.subtitle2,
            color: `${COLORS.CHARCOAL_GREY}`,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
        },
    },
    paper: {
        padding: theme.spacing(1),
    },
    grid: {
        marginTop: theme.spacing(1),
    },

    empty: {
        textAlign: 'center',
        marginTop: '30%',
        [theme.breakpoints.up('md')]: {
            marginTop: '10%',
        },
    },

    empty_image: {
        width: '45vw',
        [theme.breakpoints.up('md')]: {
            width: '25vw',
        },
    },

    productCard: {
        display: 'flex',
        flexDirection: 'row',

        '& #imgContainer': {
            display: 'flex',
            alignItems: 'center',
            paddingRight: '12px ',
            flex: 1,
            '& #productImg': {
                width: '100%',
            },
        },

        '& #productInfo': {
            display: 'flex',
            flexDirection: 'column',
            flex: 2,
            //padding: '10px',
            gap: '5px',
            '& #licenseInfo': {
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '5px',
                '& #licenseName': {
                    display: 'flex',
                    alignItems: 'center',
                    color: COLORS.WATER_BLUE,
                    fontSize: '1.2rem',
                    fontWeight: 'bold',
                },
                '& #licenseLevel': {
                    display: 'flex',
                    alignItems: 'center',
                    borderRadius: '10px',
                    padding: '4px 8px',
                    background: '#C2E9FF',
                    color: COLORS.WATER_BLUE,
                    fontSize: '1rem',
                },
            },
            '& #productStatus': {
                display: 'flex',
                flexDirection: 'row',
                gap: '5px',
                fontSize: '0.8rem',
                fontWeight: 'normal',
                textAlign: 'center',
                color: COLORS.WATER_BLUE,
                '& #productPrice, & #productComplete, & #productWait': {
                    background: '#C2E9FF',
                    borderRadius: '5px',
                    padding: '8px 4px',
                    flex: 1,
                },
            },
            '& #materialStatus1, & #materialStatus2, & #materialStatus3, & #materialStatus4':
                {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '90px',
                    padding: '8px 10px',
                    borderRadius: '5px',
                    fontSize: '1rem',
                    fontWeight: 'bold',
                },
            '& #materialStatus1': {
                border: '1px solid #1AB82D',
                background: '#D6FBCE',
                color: '#1AB82D',
            },
            '& #materialStatus2': {
                border: '1px solid #F14242',
                background: '#FBCECE',
                color: '#F14242',
            },
            '& #materialStatus3': {
                display: 'flex',
                flexDirection: 'column',
                border: '1px solid #F14242',
                background: '#FBCECE',
                color: '#F14242',
                alignItems: 'flex-start',
                fontSize: '0.7rem',
                '& #insufficientMaterial': {
                    width: '100%',
                    overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: '5px',
                },
            },
            '& #materialStatus4': {
                background: '#C2E9FF',
                color: COLORS.WATER_BLUE,
            },
            '& #productButtonContainer': {
                display: 'flex',
                justifyContent: 'space-between',
                gap: '5px',

                '& #doubleButton': {
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '5px',
                    fontWeight: 'bold',
                    color: 'white',
                    border: 'none',
                    padding: '5px',
                    background: COLORS.WATER_BLUE,
                    '& #titleText': {
                        fontSize: '0.8rem',
                    },
                    '& #subtitleText': {
                        fontSize: '0.65rem',
                    },
                },
            },
            '& #buttonOn, & #buttonOff': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '5px',
                fontSize: '1rem',
                fontWeight: 'bold',
                color: 'white',
                border: 'none',
                padding: '5px',
            },
            '& #buttonOn': {
                background: COLORS.WATER_BLUE,
            },
            '& #buttonOff': {
                background: '#CFCFCF',
            },
        },
    },
}));

interface iUnEff {
    materialCode: number;
    materialName: string;
    materialSubName: string;
    materialImage: string;
    materialPrice: number;
    materialCount: number;
}

interface iCompanyInfo {
    companyNum: number;
    companyName: string;
}

const ProductList: React.FC<any> = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const { member } = props;

    const [product, setProduct] = useState<any>([]);
    const [dialog, setDialog] = useState(-1);
    const [loading, setLoading] = useState(false);
    const [successSell, setSuccessSell] = useState(false);
    const [companyList, setCompanyList] = useState<iCompanyInfo[]>([]);
    const [reset, setReset] = useState<boolean>(false);

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const timer = useRef<number | 0>(0);
    //const down = useRef<number | 3 > (3);

    const resetStates = () => {
        setReset(true); // 초기화 트리거
        setTimeout(() => setReset(false), 0); // 초기화 후 다시 초기화 상태를 false로
    };

    const AddComma = (num: number) => {
        var regexp = /\B(?=(\d{3})+(?!\d))/g;
        return num.toString().replace(regexp, ',');
    };

    const handleDialogOpen = (index: number) => {
        if (dialog == -1) {
            setDialog(index);
        }
    };

    const handleDialogClose = () => {
        // setDialog((prevState) => prevState - prevState -1)
        setDialog((prevState) => -1);
    };

    const handleNoClose = () => {};

    const successDialogOpen = () => {
        setSuccessSell(true);
        setLoading(false);

        console.log(timer.current);
        if (timer.current != 0) {
            window.clearTimeout(timer.current);
        }
        console.log(timer.current);

        timer.current = window.setTimeout(() => {
            setSuccessSell(false);
            resetStates();
            getProductionList();
        }, 3000);
    };

    const getDialogContext = () => {
        const tProduct: any = product[dialog];
        const minPrice: number = tProduct.productPrice * (9 / 10);
        const maxPrice: number = tProduct.productPrice * (11 / 10);
        if (member.classVersion === 4 || member.classVersion === 5)
            return `최소: ${AddComma(Math.floor(minPrice))}원, 최대: ${AddComma(
                Math.floor(maxPrice)
            )}원`;
        else
            return `Lv. ${tProduct.productLicenseLevel} ${
                tProduct.productName
            }, ${AddComma(tProduct.productPrice)}원`;
    };

    const getCompanyList = () => {
        let url = new URL(
            basic.server + v_member.member + v_member.decompose_company_list
        );
        let params = { classCode: member.classCode };
        url.search = new URLSearchParams(params).toString();

        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => res.data)
            .then((data: any) => {
                if (data.code == Values.SUCCESS_CODE) {
                    setCompanyList(data.companyList);
                    console.log('company list? ', data.companyList);
                }
            });
    };

    const getProductionList = () => {
        let url = new URL(SERVER + v_member.member + v_product.production_list);
        let params = { companyNum: member.companyNum.toString() };
        url.search = new URLSearchParams(params).toString();

        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => res.data)
            .then((data: any) => {
                console.log(data);
                if (data.code == Values.SUCCESS_CODE) {
                    //setProduct((prevState: any) => data.products.reverse());
                    setProduct((prevState: any) => data.products);
                    setLoading((prevState) => true);
                }
            });
    };

    const postProductSaleApplication = (companyNum: number) => {
        const targetProduct: any = product[dialog];
        if (companyNum === undefined || companyNum === 0) {
            enqueueSnackbar('판매할 회사를 선택해주세요.', {
                variant: 'warning',
                autoHideDuration: SNACKBAR_TIME,
                translate: 'no',
            });
            return;
        }
        axios({
            method: 'POST',
            data: {
                companyNum: member.companyNum.toString(),
                memberName: member.name.toString(),
                productNum: targetProduct.productNum.toString(),
                productName: targetProduct.productName.toString(),
                classCode: member.classCode.toString(),
                classVersion: member.classVersion,
                decomposeCompanyNum: companyNum,
            },
            withCredentials: true,
            url:
                basic.server + v_member.member + v_product.sale_application_new,
        })
            .then((res) => res.data)
            .then((data: any) => {
                console.log(data);
                if (data.code == Values.SUCCESS_CODE) {
                    successDialogOpen();
                    enqueueSnackbar(ToastStr.PRODUCT_SALE_APP_SUCCESS, {
                        variant: 'success',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                } else if (data.code == Values.INSUFFICIENT_CODE) {
                    enqueueSnackbar(ToastStr.PRODUCT_SALE_APP_FINISH_FAIL, {
                        variant: 'warning',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                    getProductionList();
                    resetStates();
                }
            });
        handleDialogClose();
    };

    const postProductSaleApplication2 = (price: number, companyNum: number) => {
        const minPrice: number = Math.floor(
            product[dialog].productPrice * (9 / 10)
        );
        const maxPrice: number = Math.floor(
            product[dialog].productPrice * (11 / 10)
        );
        if (price < minPrice || price > maxPrice) {
            enqueueSnackbar(ToastStr.PRODUCT_PRICE_WRONG_STR, {
                variant: 'warning',
                autoHideDuration: SNACKBAR_TIME,
                translate: 'no',
            });
            return;
        }
        if (companyNum === undefined || companyNum === 0) {
            enqueueSnackbar('판매할 회사를 선택해주세요.', {
                variant: 'warning',
                autoHideDuration: SNACKBAR_TIME,
                translate: 'no',
            });
            return;
        }
        const targetProduct: any = product[dialog];
        axios({
            method: 'POST',
            data: {
                companyNum: member.companyNum.toString(),
                memberName: member.name.toString(),
                productNum: targetProduct.productNum.toString(),
                productName: targetProduct.productName.toString(),
                classCode: member.classCode.toString(),
                price: price.toString(),
                classVersion: member.classVersion,
                decomposeCompanyNum: companyNum,
            },
            withCredentials: true,
            url:
                basic.server +
                v_member.member +
                v_product.sale_application_price,
        })
            .then((res) => res.data)
            .then((data: any) => {
                console.log(data);
                if (data.code == Values.SUCCESS_CODE) {
                    successDialogOpen();
                    enqueueSnackbar(ToastStr.PRODUCT_SALE_APP_SUCCESS, {
                        variant: 'success',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                } else if (data.code == Values.INSUFFICIENT_CODE) {
                    enqueueSnackbar(ToastStr.PRODUCT_SALE_APP_FINISH_FAIL, {
                        variant: 'warning',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                    getProductionList();
                    resetStates();
                }
            });
        handleDialogClose();
    };

    const goOrderList = () => {
        history.push({
            pathname: '/productOrderList/',
            state: {
                // location state
            },
        });
    };

    useEffect(() => {
        const fetchData = async () => {
            await getProductionList();
            await getCompanyList();
        };
        fetchData();
    }, []);

    return (
        <div className="contentSmallPdTop">
            <div
                style={{
                    textAlign: 'right',
                    marginLeft: 'auto',
                    paddingBottom: '2vh',
                }}
            >
                <Button
                    className={classes.button3}
                    variant="contained"
                    onClick={goOrderList}
                >
                    제품 영수증
                </Button>
            </div>
            <Box display="flex" justifyContent="center" alignItems="center">
                <List className={classes.list}>
                    {loading == true ? (
                        product.length != 0 ? (
                            product.map((item: any, index: number) => {
                                return (
                                    <ListItem
                                        className={classes.productItem}
                                        alignItems="center"
                                    >
                                        <ProductItem
                                            {...item}
                                            handleButton={() =>
                                                handleDialogOpen(index)
                                            }
                                            AddComma={AddComma}
                                            loading={true}
                                            companyNum={member.companyNum}
                                            classVersion={member.classVersion}
                                            reset={reset}
                                        />
                                    </ListItem>
                                );
                            })
                        ) : (
                            <div className={classes.empty}>
                                <img
                                    className={classes.empty_image}
                                    src={'/images/no_product.webp'}
                                />
                                <Typography
                                    variant="h1"
                                    style={{
                                        color: `${COLORS.DOWN}`,
                                        marginTop: '1.5vh',
                                    }}
                                >
                                    판매할 제품이 없습니다.
                                </Typography>
                            </div>
                        )
                    ) : (
                        Array.from(Array(5), (e, i) => {
                            return (
                                <ListItem
                                    className={classes.productItem}
                                    alignItems="center"
                                >
                                    <ProductItem loading={false} />
                                </ListItem>
                            );
                        })
                    )}
                </List>
            </Box>
            {dialog >= 0 &&
                (member.classVersion === 4 || member.classVersion === 5 ? (
                    <DialogInputConfirm
                        open={dialog < 0 ? false : true}
                        handleClose={() => handleDialogClose()}
                        title={'판매할 회사와, 가격을 선택해주세요.'}
                        //context ={(10 - timer.current) + "하이"}
                        companyList={companyList}
                        price={product[dialog].productPrice}
                        context={getDialogContext()}
                        yesConfirm={postProductSaleApplication2}
                        noConfirm={() => handleDialogClose()}
                    />
                ) : (
                    <DialogSelectCompany
                        open={dialog < 0 ? false : true}
                        handleClose={() => handleDialogClose()}
                        title={'판매할 회사를 선택해주세요.'}
                        companyList={companyList}
                        //context={getDialogContext()}
                        context={getDialogContext()}
                        yesConfirm={postProductSaleApplication}
                        //yesConfirm={postMaterialOrder}
                        noConfirm={handleDialogClose}
                    />
                ))}
            {successSell && (
                <DialogPopup
                    open={successSell == true ? true : false}
                    handleClose={() => handleNoClose()}
                    title={'주문 성공!'}
                    context={'3초 후 자동으로 창이 닫힙니다.'}
                />
            )}
        </div>
    );
};

const ProductItem: React.FC<any> = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const { enqueueSnackbar } = useSnackbar();
    const [checkStatus, setCheckStatus] = useState<number>(0);
    const [uneff, setUneff] = useState<null | iUnEff[]>(null);

    const movePage = (page: string) => {
        history.push({
            pathname: page,
        });
    };

    const getProductMaterialStatus = () => {
        let url = new URL(
            SERVER + v_member.member + v_product.product_material_status
        );
        let params = {
            companyNum: props.companyNum.toString(),
            classVersion: props.classVersion,
            productName: props.productName,
        };
        url.search = new URLSearchParams(params).toString();

        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => res.data)
            .then((data: any) => {
                console.log(data);

                if (data.code == Values.SUCCESS_CODE) {
                    setCheckStatus(3);
                    enqueueSnackbar(
                        ToastStr.PRODUCT_SALE_APP_CHECK_SUFFICIENT_SUCCESS,
                        {
                            variant: 'success',
                            autoHideDuration: SNACKBAR_TIME,
                            translate: 'no',
                        }
                    );
                } else if (data.code == Values.INSUFFICIENT_CODE) {
                    setUneff(data.products);
                    if (data.products.length < 4) {
                        setCheckStatus(2);
                    } else {
                        setCheckStatus(1);
                    }
                    enqueueSnackbar(
                        ToastStr.PRODUCT_SALE_APP_CHECK_INSUFFICIENT_FAIL,
                        {
                            variant: 'warning',
                            autoHideDuration: SNACKBAR_TIME,
                            translate: 'no',
                        }
                    );
                }
            });
    };

    const renderCheckStatus = () => {
        switch (checkStatus) {
            case 0:
                return (
                    <Button
                        id="materialStatus1"
                        onClick={getProductMaterialStatus}
                    >
                        <div>판매 가능 한가요?</div>
                        <img
                            src={'images/cursor-click.svg'}
                            style={{ width: '14px', marginLeft: '6px' }}
                        ></img>
                    </Button>
                );
            case 1:
                return <div id="materialStatus2">재료가 많이 부족해요.</div>;
            case 2:
                return (
                    <div id="materialStatus3">
                        <div>아래 재료만 추가로 구매하면 돼요!</div>
                        <div id="insufficientMaterial">
                            {uneff &&
                                uneff.map((item, index) => (
                                    <div key={index}>
                                        {item.materialName +
                                            ', ' +
                                            item.materialCount}
                                        {'개'}
                                    </div> // 배열의 각 항목에서 이름 렌더링
                                ))}
                        </div>
                    </div>
                );
            case 3:
                return <div id="materialStatus4">판매할 수 있어요!</div>;
            default:
                return (
                    <Button
                        id="materialStatus1"
                        onClick={getProductMaterialStatus}
                    >
                        <div>판매 가능 한가요?</div>
                        <img
                            src={'images/cursor-click.svg'}
                            style={{ width: '14px', marginLeft: '6px' }}
                        ></img>
                    </Button>
                );
        }
    };

    const renderButton = () => {
        switch (checkStatus) {
            case 0:
                return (
                    <Button id="buttonOff" disabled={true}>
                        제품 판매하기
                    </Button>
                );
            case 1:
                return (
                    <Button
                        id="buttonOn"
                        onClick={() => movePage('/MaterialPurchase')}
                    >
                        재료 사러가기
                    </Button>
                );
            case 2:
                return (
                    <div id="productButtonContainer">
                        <button
                            id="doubleButton"
                            onClick={() => {
                                movePage('/OrderList');
                            }}
                        >
                            <div id="titleText">내가 안 샀다고?</div>
                            <div id="subtitleText">영수증 확인하기</div>
                        </button>
                        <button
                            id="doubleButton"
                            onClick={() => {
                                movePage('/MaterialPurchase');
                            }}
                        >
                            <div id="titleText">얼른 사러 가자!</div>
                            <div id="subtitleText">재료 구매하기</div>
                        </button>
                    </div>
                );
            case 3:
                return (
                    <Button id="buttonOn" onClick={props.handleButton}>
                        제품 판매하기
                    </Button>
                );
            default:
                return (
                    <Button id="buttonOff" disabled={true}>
                        제품 판매하기
                    </Button>
                );
        }
    };

    useEffect(() => {
        setCheckStatus(0);
        setUneff(null);
    }, [props.reset]);

    if (props.loading) {
        return (
            <div
                id="itemWrap"
                style={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                }}
                translate="no"
            >
                <div className={classes.productCard}>
                    <div id="imgContainer">
                        <img
                            id="productImg"
                            src={
                                basic.server +
                                '/displayImage?fileName=' +
                                props.productImage
                            }
                        />
                    </div>
                    <div id="productInfo">
                        <div id="licenseInfo">
                            <div id="licenseName">{props.productName}</div>
                            <div id="licenseLevel">
                                {'Lv.' + props.productLicenseLevel}
                            </div>
                        </div>
                        <div id="productStatus">
                            <div id="productPrice">
                                <div>가격</div>
                                <div>{props.productPrice}</div>
                            </div>
                            <div id="productComplete">
                                <div>판매 완료</div>
                                <div>{props.completeNum}</div>
                            </div>
                            <div id="productWait">
                                <div>대기중</div>
                                <div>{props.waitNum}</div>
                            </div>
                        </div>
                        {renderCheckStatus()}
                        {renderButton()}
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div id="itemWrap" style={{ alignItems: 'center' }} translate="no">
                {/* <Skeleton width="80%" animation="wave" variant="rect" /> */}
                <Skeleton
                    animation="wave"
                    width="23%"
                    height="4vh"
                    variant="rect"
                />
                <div className={classes.productDesc}>
                    <Skeleton animation="wave" id="productName" width="80%" />
                    <Skeleton animation="wave" id="productPrice" width="80%" />
                </div>
                <Skeleton
                    className={classes.button}
                    style={{ backgroundColor: 'rgba(0,0,0,0.11)' }}
                    animation="wave"
                    variant="rect"
                />
            </div>
        );
    }
};

export default ProductList;
